import { Cookies as ReactCookies } from 'react-cookie';

class Cookies {

    cookies = new ReactCookies;

    set(opts) {
        this.cookies = new ReactCookies(Object.assign({}, opts));
    }
    get() {
        return this.cookies;
    }
}

export const cookies = new Cookies();
export const fetchCookies = () => cookies.cookies;



// WEBPACK FOOTER //
// ./frontend/helpers/cookies.js